'use strict';

var generatedCraftcms = require('@liquorice/generated-craftcms');

const FORMIE_FORM_FRAGMENT = generatedCraftcms.gql(`
  fragment formieForm on FormInterface {
    __typename
    id
    uid
    handle
    submissionMutationName
    slug
    rows {
      ...formieRow
    }
    captchas {
      ...formieCaptcha
    }
    settings {
      submitActionMessageHtml
      errorMessageHtml
    }
  }
`);

exports.FORMIE_FORM_FRAGMENT = FORMIE_FORM_FRAGMENT;
